import { api } from "@/api/base-api"

export type HarnessLineItemRecurringBillingFrequency =
  | "Monthly"
  | "Quarterly"
  | "BiAnnually"
  | "Annually"
  | "EveryTwoYears"
  | "EveryThreeYears"

export type HarnessRecurringBillingFrequency =
  | "Daily"
  | "Weekly"
  | "Biweekly"
  | "Monthly"
  | "Quarterly"
  | "SemiAnnually"
  | "Annually"
  | "EveryTwoYears"
  | "EveryThreeYears"
  | "EveryFourYears"
  | "EveryFiveYears"

export type HarnessSubscriptionStatus = "Active" | "PastDue" | "Unpaid" | "Canceled" | "Expired" | "Scheduled" | "Paused"

export type HarnessSubscriptionLineItem = {
  name: string | null
  amount: number | null
  billingStartDate: string | null
  recurringBillingPeriod: string | null
  recurringBillingNumberOfPayments: number | null
  recurringBillingFrequency: HarnessLineItemRecurringBillingFrequency | null
  quantity: number | null
  productCategory: string | null
}

export type HarnessSubscription = {
  subscriptionId: string | null
  subscriptionName: string | null
  nextPaymentDueDate: string | null
  status: HarnessSubscriptionStatus
  recurrenceInterval: HarnessRecurringBillingFrequency
  recurranceStartDate: string | null
  recurranceEndDate: string | null
  nextPaymentAmount: number | null
  currencyCode: string | null
  subscriptionLineItems: HarnessSubscriptionLineItem[] | null
}

export type GetHarnessSubscriptionsQueryArgs = {
  customerId: number
  subscriptionStatus?: HarnessSubscriptionStatus[]
  nextPaymentDueDateFrom?: string
  nextPaymentDueDateTo?: string
}

const subscriptionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHarnessSubscriptions: builder.query<HarnessSubscription[], GetHarnessSubscriptionsQueryArgs>({
      query: ({ customerId, ...params }) => ({
        url: `/api/providers/Harness/CloudFitPortal/Customer/${customerId}/Subscription`,
        params,
      }),
    }),
  }),
})

export const { useGetHarnessSubscriptionsQuery } = subscriptionsApi
